module.exports = __webpack_public_path__ + "static/media/Logos_Marcas.9eecef77.png";